import { useQuery } from "react-query";
import { StudentStatisticsQueryParams } from "../types/Student";
import { getStudentStatistics } from "../services/school/student/getEnrollments";

export const useGetStudentStatistics = (filters: StudentStatisticsQueryParams, options:any= null) => {
    return useQuery(["studentStatistics", filters], () => getStudentStatistics(filters), 
    options?{...options}:{}
);
};
